export default {
    INDEX: '/',
    ABOUT: '/about',
    PRIVACY: '/privacy',
    SERVICES: '/services',
    CONTACT: '/contact',
}